import ProductSamplingOverview from '../pages/ProductSamplingOverview';
import ProductSamplingDetails from '../pages/ProductSamplingDetails';
import ProductSamplingWorkflowAllocation from '../pages/ProductSamplingWorkflowAllocation';
import AllocationStatusMonitoring from '../pages/AllocationStatusMonitoring';

const productSamplingv2Route = {
  public: [
    {
      name: 'product_sampling_details_warehouse_confirmation',
      path: '/product-sampling-workflow/warehouse-confirmation',
      component: ProductSamplingDetails,
    },
    {
      name: 'product_sampling_details_status_warehouse',
      path: '/product-sampling-workflow/status',
      component: AllocationStatusMonitoring,
    },
  ],
  auth: [
    {
      name: 'product_sampling_overview_maintenance',
      path: '/maintenance/product-sampling-overview',
      permissions: ['admin', 'PM'],
      component: ProductSamplingOverview,
    },
    {
      name: 'product_sampling_details_maintenance',
      path: '/maintenance/product-sampling-details',
      permissions: ['admin', 'PM'],
      component: ProductSamplingDetails,
    },
    {
      name: 'product_sampling_details_allocation_maintenance',
      path: '/maintenance/product-sampling-details/allocation',
      permissions: ['admin', 'PM'],
      component: ProductSamplingWorkflowAllocation,
    },
    {
      name: 'product_sampling_details_status_maintenance',
      path: '/maintenance/product-sampling-details/status',
      permissions: ['admin', 'PM'],
      component: AllocationStatusMonitoring,
    },
  ],
};

export default productSamplingv2Route;
